import {Module} from '../plugins/_application';
import Siema from 'siema';
import {animate} from 'animejs';
import Barba from 'barba.js';
import $ from 'jquery';

export default class PageTransition extends Module {
	ready(app) {
		const loaderWrap = document.querySelector('.loader-wrapper');
		// Add the no-barba class to the links in the WP admin bar
		adminDisableBarba();
		initMap(document);

		// Change the default container and initialize barba
		Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;
		Barba.Pjax.Dom.wrapperId = 'mtt-wrapper';
		Barba.Pjax.Dom.containerClass = 'mtt-container';
		Barba.Pjax.start();

		Barba.Dispatcher.on('newPageReady', function(currentStatus, prevStatus, HTMLElementContainer, newPageRawHTML) {
			noBarbaOnLinks();

			// CF7 Ajax init
			const contactFormContainer = HTMLElementContainer.querySelector('div.wpcf7 > form');
			if (contactFormContainer) {
			  const contactForms = document.querySelectorAll('div.wpcf7 > form');
	  
			  for (let i = 0; i < contactForms.length; i++) {
				const element = contactForms[i];
				wpcf7.initForm(element);
			  }
			}
	  
			// Update the admin bar links on new page ready
			if (document.getElementById('wpadminbar')) {
			  const newDoc = parseHTML(newPageRawHTML); 
			  const newPageAdminBar = newDoc.getElementById('wpadminbar');
		
			  document.getElementById('wpadminbar').innerHTML = newPageAdminBar.innerHTML;
			  adminDisableBarba();
			}
	  
			// Google maps
			initMap(HTMLElementContainer);	  

			// Reinit Siema
			if($(document).find('.siema').length){

				$('.loading-items-wrapper').removeClass('hidden');
				
				let LOGO_SLIDER = new Siema({
					perPage: {
						320: 1,
						400: 2,
						580: 3,
						768: 4,
						1024: 5,
						1920: 6,
						2400: 8,
					},
					loop: true,
					duration: 200,
					onInit() { showSiema(); }
				});
				let prev = document.querySelector('.arrow-left-container');
				let next = document.querySelector('.arrow-right-container');
				
				prev.addEventListener('click', () => LOGO_SLIDER.prev());
				next.addEventListener('click', () => LOGO_SLIDER.next());
			
				function showSiema(){

					$('.loading-items-wrapper').addClass('hidden');
			
					let delay = 0;
			
					$('.siema-item').each(function(){
						let THIS_SLIDE = $(this);
						setTimeout(function(){
							$(THIS_SLIDE).addClass('visible');
						}, delay);
						delay += 60;
					});
				}

			}

		});

		function noBarbaOnLinks(){
			$('a').each(function(){
				var url = $(this).attr('href');

				if (url != undefined && url.indexOf("/produkt/") > -1) {
					$(this).addClass('no-barba');
				}

			});
		}
		noBarbaOnLinks();

		// Create a transition
		var FadeTransition = Barba.BaseTransition.extend({
			start: function () {
				Promise
					.all([this.newContainerLoading, this.fadeOut()])
					.then(this.fadeIn.bind(this));
			},

			fadeOut: function () {
				loaderWrap.classList.add('show');

				return new Promise((resolve, reject) => {
					animate(this.oldContainer, {
						opacity: [1, 0],
						ease: 'inOutSine',
						duration: 300,
						onComplete: function () {
							window.scrollTo(0, 0);
							resolve();
						}
					});
				});
			},

			fadeIn: function () {
				var _this = this;
				var el = this.newContainer;

				this.oldContainer.style.display = 'none';

				el.style.opacity = 0;
				el.style.visibility = 'visible';

				loaderWrap.classList.remove('show');

				animate(el, {
					opacity: [0, 1],
					ease: 'inOutSine',
					duration: 300,
					onComplete: function () {
						_this.done();
					}
				})
			}
		});

		// Initialize transition
		Barba.Pjax.getTransition = function () {
			return FadeTransition;
		};
	}
}

// Functions regarding wordpress admin fixes
function parseHTML(html) {
	let parser = new DOMParser();
	return parser.parseFromString(html, 'text/html');
}

// Add the no-barba class to the links in the WP admin bar
function adminDisableBarba() {
	var adminLinks = document.querySelectorAll('#wpadminbar a');

	if (adminLinks.length) {
		for (var i = adminLinks.length - 1; i >= 0; i--) {
			adminLinks[i].classList.add('no-barba');
		}
		;
	}
}

// Google maps
function setupMap(title, latitude, longitude, zooming, style, container) {
  const myLatLng = {lat: latitude, lng: longitude};

  const map = new window.google.maps.Map(container, {
    zoom: zooming,
    center: myLatLng,
    styles: style
  });

  const marker = new window.google.maps.Marker({
    position: myLatLng,
    map: map,
    title: title
  });
}

function initMap(doc) {
	const mapsWrap = doc.querySelector('#map');
		
	if (mapsWrap) {
		let title = mapsWrap.getAttribute('data-title');
		let lat = parseFloat(mapsWrap.getAttribute('data-lat'));
		let lng = parseFloat(mapsWrap.getAttribute('data-lng'));
		let zoom = parseFloat(mapsWrap.getAttribute('data-zoom'));
		let styleContainer = doc.querySelector('#map-style script')
		let style = false;

		if (styleContainer) {
			style = JSON.parse(styleContainer.innerHTML);
		}

		setupMap(title, lat, lng, zoom, style, mapsWrap);
	}
}